import { render, staticRenderFns } from "./flugstrecken-vergleich-hinRueck.vue?vue&type=template&id=4d00f020&scoped=true"
import script from "./flugstrecken-vergleich-hinRueck.vue?vue&type=script&lang=js"
export * from "./flugstrecken-vergleich-hinRueck.vue?vue&type=script&lang=js"
import style0 from "./flugstrecken-vergleich-hinRueck.vue?vue&type=style&index=0&id=4d00f020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d00f020",
  null
  
)

export default component.exports